<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      orientation?: 'vertical' | 'horizontal';
    }>(),
    {
      orientation: 'horizontal',
    },
  );
</script>

<template>
  <div
    data-slot="card-header"
    :class="
      cn(
        '@container/card-header gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
        orientation === 'vertical'
          ? 'grid auto-rows-min grid-rows-[auto_auto] items-start'
          : 'flex flex-row items-center justify-between',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
